/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, OnInit, ViewChild, AfterViewInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DistributionExportService } from './services/distribution-export.service';
import { DistributionService } from './services/distribution.service';
import { DistributionSearchResult, DistributionObjectContainer, DistributionSearch } from './models/distribution-search-result';
import { acknowledgementOptions } from './models/acknowledgementOption';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { LoadingPanelService } from '../shared/loading-panel/loading-panel.service';
import { DateTimeService } from '../shared/datetime/datetime.service';
import { GenericModalService } from '../shared/generic-modal/generic-modal.service';
import { StateService } from '../shared/state-management/state.service';
import { CurrentUserService } from '../user/services/current-user.service';
import { AlertService } from '../alerts/services/alert.service';
import { ConfigurationService } from '../configuration/services/configuration.service';
import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';
import { RestrictedSearchCalloutComponent } from '../shared/restricted-search/restricted-search.component';

import { FormsModule } from '@angular/forms';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoStateStoringModule, DxiColumnModule, DxoLookupModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { BizDateColumnDirective } from '../shared/grid/biz-grid-date.directive';
import { BizUserColumnDirective } from '../shared/grid/biz-grid-user.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { StatusTrafficLightComponent } from '../shared/status-traffic-light/status-traffic-light.component';
import { BizGridFiltervalues } from '../shared/grid/biz-grid-filtervalues';

@Component({
    templateUrl: './distribution-search-result.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PermissionRequiredDirective, SvgIconComponent, RestrictedSearchCalloutComponent, FormsModule, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, DxDataGridModule, BizDataGridDirective, DxoStateStoringModule, DxiColumnModule, BizDateColumnDirective, DxoLookupModule, DxiValidationRuleModule, BizUserColumnDirective, DxTemplateModule, StatusTrafficLightComponent]
})

export class DistributionSearchResultComponent implements AfterViewInit, OnInit {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private modalService = inject(GenericModalService);
    private loadingPanelService = inject(LoadingPanelService,);
    private stateService = inject(StateService);
    private exportService = inject(DistributionExportService);
    private currentUserService = inject(CurrentUserService,);
    private alertService = inject(AlertService);
    private distributionService = inject(DistributionService);
    private configurationService = inject(ConfigurationService);
    public bizGridFiltervalues = inject(BizGridFiltervalues);
    public dateTimeService = inject(DateTimeService);

    constructor() {
        this.dateFormat = this.dateTimeService.getDevExpressDateTimeFormat();
    }

    @ViewChild(BizDataGridDirective, { static: true }) private datagrid: BizDataGridDirective;

    public stateObject: TrackingResultStateObject = new TrackingResultStateObject();
    public acknowledgementOptions = acknowledgementOptions;

    static readonly trackingFieldPrefix: string = 'trackingField_';
    readonly stateKey: string = 'distribution-search-result-state';
    public dateFormat: any;
    public isFallbackColumnVisible: boolean = false;
    public isLoading = false;
    private hasDistributionEditPermission: boolean = false;
    private hasExportPermission: boolean = false;
    private hasTrackingSearchResultPermission: boolean = false;
    private hasPartnerViewDetailPermission: boolean = false;

    ngOnInit() {
        this.hasExportPermission = this.currentUserService.hasPermission('Distribution_Action_DistributionExport');
        this.hasDistributionEditPermission = this.currentUserService.hasPermission('Distribution_Action_DistributionEdit');
        this.hasTrackingSearchResultPermission = this.currentUserService.hasPermission('Tracking_View_SearchResult');
        this.hasPartnerViewDetailPermission = this.currentUserService.hasPermission('Partner_View_PartnerDetails');
        this.route.params.subscribe(parms => {
            let loadState = false;
            const stateObject = this.stateService.getState(this.stateKey);
            if (stateObject) {
                // TODO: Is there a better way to compare two objects without comparing the object-reference? This is fast but not scalable. The order of the properties must be the same using this method.
                const previousParms = JSON.stringify(stateObject.parms);
                const currentParms = JSON.stringify(parms);
                loadState = previousParms == currentParms;
            }

            if (loadState) {
                this.stateObject = stateObject;
                if (this.stateObject.refreshData === true) {
                    this.refresh();
                }
            }
            else {
                this.stateObject.parms = parms;
                this.refresh();
            }
        });
    }

    ngAfterViewInit(): void {
        this.initializeContextMenu();
        this.datagrid.rowDoubleClick.subscribe(row => this.showGivenDistributions([row]));
        this.datagrid.instance.refresh(); // For some reason needed. Otherwise the columns will disappear when the component is invoked again. This might be because some logic are moved from this ngAfterViewInit to ngOnInit
    }

    initializeContextMenu() {
        this.datagrid.instance.option('onContextMenuPreparing', (e) => {
            if (e.row.rowType === 'data') {
                if (this.stateObject.selectedRows.length > 0) {
                    e.items = [];

                    e.items.push({
                        text: 'Show selected distribution(s)',
                        onItemClick: () => {
                            this.showDistributions();
                        }
                    });

                    if (this.hasDistributionEditPermission) {
                        if (this.enableOrDisableDistributionsContext() === 'enable') {
                            e.items.push({
                                text: 'Enable selected distribution(s)',
                                onItemClick: () => {
                                    void this.toggleDistributionsIsActive(true);
                                }
                            });
                        }
                        else if (this.enableOrDisableDistributionsContext() === 'disable') {
                            e.items.push({
                                text: 'Disable selected distribution(s)',
                                onItemClick: () => {
                                    void this.toggleDistributionsIsActive(false);
                                }
                            });
                        }
                    }

                    if (this.hasExportPermission) {
                        e.items.push({
                            text: 'Export selected distribution(s)',
                            onItemClick: () => {
                                void this.export();
                            }
                        });
                    }


                    if (this.stateObject.selectedRows.length == 1) {
                        const row = this.stateObject.selectedRows[0];

                        if (this.hasTrackingSearchResultPermission) {
                            e.items.push({
                                text: 'Search for documents',
                                onItemClick: () => {
                                    const searchParams: any = { distributionId: row.DistributionId };
                                    void this.router.navigate(['tracking/result', searchParams]);
                                }
                            });
                        }

                        if (this.hasPartnerViewDetailPermission) {
                            e.items.push({
                                text: 'Edit "To-configuration"',
                                onItemClick: () => {
                                    this.loadingPanelService.showLoadingPanelDirect('Navigating to Partner...');
                                    const searchParams: any = {openOnLocation: true, partnerIds: row.ToPartnerId, showTransportConfiguration: true, transportConfigurationId: row.TransportConfigurationToId };
                                    void this.router.navigate(['partner/details', searchParams]);
                                }
                            });
                        }
                    }
                }
            }
        });
    }

    refresh() {
        this.isLoading = true;
        this.distributionService.searchDistributions(this.stateObject.parms).then(result => {
            result ??= { DistributionGroups: [], IsDistributionSearchResultRestricted: false, ServerSearchTime: '' };
            result.DistributionGroups ??= [];
            result.DistributionGroups.sort((dg1, dg2) => dg1.DistributionObjectGroupName.localeCompare(dg2.DistributionObjectGroupName)); // Sort the groups by name

            // Store the previous selected distribution-object-groups
            let anyPreviousSelected: boolean = false;
            if (this.stateObject.searchResult) {
                this.stateObject.searchResult.DistributionGroups.filter((dg) => dg['selected'] === true).forEach((dg) => { // Find previous selected
                    const existingGroup = result.DistributionGroups.find((d) => d.DistributionObjectGroupId == dg.DistributionObjectGroupId); // Find the correct object-reference in the new result
                    if (existingGroup) {
                        existingGroup['selected'] = true;
                        anyPreviousSelected = true;
                    }
                });
            }

            this.stateObject.searchResult = result;

            if (!anyPreviousSelected && result.DistributionGroups.length > 0) { // Select the first group if no previous selected groups have been found
                result.DistributionGroups.forEach(dg => { dg['selected'] = true; });
            }

            result.DistributionGroups.forEach(dg => {
                dg.DistributionObjectContainers.forEach(doc => {
                    doc.Distributions.forEach(d => {
                        d['ConcatenatedFormatVariantVersionFrom'] = `${d.FromFormat}/${d.FromVariant}/${d.FromVersion}`;
                        d['ConcatenatedFormatVariantVersionTo'] = `${d.ToFormat}/${d.ToVariant}/${d.ToVersion}`;
                    });
                });
            });

            this.selectedGroupsChanged();

            this.stateService.setState(this.stateKey, this.stateObject);
            this.isLoading = false;
        }).catch(() => this.isLoading = false);
    }

    reset() {
        this.datagrid.reset(false);
    }

    async export() {
        const distributionIds = this.stateObject.selectedRows.map<number>((r) => r.DistributionId);
        if (distributionIds.length > 0) {
            this.loadingPanelService.showLoadingPanelDirect('Exporting distributions...');

            const includeArtifacts = await this.includeArtifactsInExport();
            await this.exportService.exportDistributions(distributionIds, includeArtifacts);
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    selectedGroupsChanged() {
        this.stateObject.distributionObjectsContainers = this.stateObject.searchResult.DistributionGroups
            .filter((g: any) => g.selected) // Get all selected groups
            .flatMap((g: any) => g.DistributionObjectContainers)
            .sort((dc1, dc2) => dc1.DistributionObjectName.localeCompare(dc2.DistributionObjectName)) as DistributionObjectContainer[]; // Sort the array by distribution-object-name

        if (this.stateObject.distributionObjectsContainers.length > 1) { // Only show "Show all" if there are more than one distribution-object to show
            let allDistributions = [];
            this.stateObject.distributionObjectsContainers.forEach((doc) => allDistributions = allDistributions.concat(doc.Distributions));
            const allDistributionObjectContainer: DistributionObjectContainer = {
                DistributionObjectName: 'Show All',
                DistributionObjectId: -1,
                DistributionObjectDescription: 'Show All',
                Distributions: allDistributions
            };

            this.stateObject.distributionObjectsContainers.push(allDistributionObjectContainer);
        }

        // If there is a previous selected distribution-object - find the correct object-reference in the new result.
        if (this.stateObject.selectedDistributionObjectContainer) {
            this.stateObject.selectedDistributionObjectContainer = this.stateObject.distributionObjectsContainers.find((doc) => doc.DistributionObjectId == this.stateObject.selectedDistributionObjectContainer.DistributionObjectId);
        }
        // If no previously selected - select the first distribution-object
        if (!this.stateObject.selectedDistributionObjectContainer && this.stateObject.distributionObjectsContainers.length > 0) {
            this.stateObject.selectedDistributionObjectContainer = this.stateObject.distributionObjectsContainers[0];
        }

        this.selectedDistributionObjectsChanged();
    }

    selectedDistributionObjectsChanged() {
        if (this.stateObject.selectedDistributionObjectContainer) {
            // If "Show all" is chosen - show the distribution-object column
            this.datagrid.instance.columnOption('DistributionObjectName', 'visible', this.stateObject.selectedDistributionObjectContainer.DistributionObjectId == -1);
            this.stateObject.distributions = this.stateObject.selectedDistributionObjectContainer.Distributions;

            this.datagrid.instance.state(null);

            this.isFallbackColumnVisible = this.stateObject.selectedDistributionObjectContainer.Distributions.some(ds => this.distributionService.isFallbackDistributionSearch(ds));
        }
        else {
            this.stateObject.distributions = [];
            this.stateObject.trackingColumns = [];
            this.isFallbackColumnVisible = false;
        }
    }

    selectionChanged(e: any) {
        this.stateObject.selectedRows = e.selectedRowsData;
    }

    showDistributions() {
        this.showGivenDistributions(this.stateObject.selectedRows);
    }

    enableOrDisableDistributionsContext(): string {
        return this.stateObject.selectedRows.some(e => e.IsActive === true) ? 'disable' : 'enable';
    }

    async toggleDistributionsIsActive(isActive: boolean): Promise<void> {
        const distributionIds = this.stateObject.selectedRows.filter(x => x.IsActive === !isActive).map<number>((r) => r.DistributionId);
        let requestText = `'Do you want to ${isActive ? 'enable' : 'disable'} ${distributionIds.length} distribution(s)?`;
        if (this.stateObject.selectedRows.length > 1 && this.stateObject.selectedRows.length !== distributionIds.length) {
            requestText = `You have selected ${this.stateObject.selectedRows.length} distributions. ${distributionIds.length} will be ${isActive ? 'enabled' : 'disabled'}.`;
        }

        await this.modalService.confirmDirect(`${isActive ? 'Enable' : 'Disable'} Distributions`, requestText).then(async () => {
            this.loadingPanelService.showLoadingPanelDirect(`${isActive ? 'Enabling' : 'Disabling'} distributions`);
            await this.distributionService.setDistributionsIsActive(distributionIds, isActive);
        }).catch(() => {

        }).finally(() => {
            this.loadingPanelService.hideLoadingPanel();
            this.refresh();
        });
    }

    showGivenDistributions(distributionsToShow: any[]) {
        const distributionIds = distributionsToShow.map<number>((r) => r.DistributionId);
        if (distributionIds.length > 0) {

            if (distributionIds.length > DistributionService.maxNumberOfDistributionsToShow) {
                const maxDocuments = DistributionService.maxNumberOfDistributionsToShow;
                void this.modalService.messageDirect('Maximum number of distributions', `Maximum number of distributions to show is ${maxDocuments}`);
            }
            else {
                const parms = { distributionIds: distributionIds.join(',') };
                void this.router.navigate(['distribution/result/details', parms]);
            }
        }
    }

    createNew() {
        void this.router.navigate(['distribution/result/details', { createNew: true }]);
    }

    alertStatusTooltip(latestAlertStatus: string): string {
        return this.alertService.getAlertStatusTooltip(latestAlertStatus);
    }

    async includeArtifactsInExport(): Promise<boolean> {
        const hasExportArtifactsPermission = this.currentUserService.hasPermission('ImportExport_Action_ExportArtifacts');
        let defaultIncludeArtifacts = true;
        await this.configurationService.getEffectiveSettingBoolean('IncludeArtifactsInExport').then(res => defaultIncludeArtifacts = res ?? true)
        return defaultIncludeArtifacts && hasExportArtifactsPermission;
    }

    isFallbackDistribution(distribution: DistributionSearch): boolean {
        return this.distributionService.isFallbackDistributionSearch(distribution);
    }

    fallbackDistributionDirection(distribution: DistributionSearch): string {
        const direction = this.distributionService.fallbackDirectionSearch(distribution);
        return direction ? direction.toString() : '';
    }

    readonly calculateIsFallback = (row: DistributionSearch) =>
        this.distributionService.isFallbackDistributionSearch(row);
}

class TrackingResultStateObject {
    public distributions: DistributionSearch[];
    public searchResult: DistributionSearchResult;
    public distributionObjectsContainers: DistributionObjectContainer[] = [];
    public selectedDistributionObjectContainer: DistributionObjectContainer;
    public selectedRows: any[] = [];
    public trackingColumns: any[] = [];
    public parms: any;

    public refreshData: boolean;
}
